namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class RoleDialog extends Serenity.EntityDialog<RoleRow, any> {
        protected getFormKey() { return RoleForm.formKey; }
        protected getIdProperty() { return RoleRow.idProperty; }
        protected getLocalTextPrefix() { return RoleRow.localTextPrefix; }
        protected getNameProperty() { return RoleRow.nameProperty; }
        protected getService() { return RoleService.baseUrl; }
        protected getDeletePermission() { return RoleRow.deletePermission; }
        protected getInsertPermission() { return RoleRow.insertPermission; }
        protected getUpdatePermission() { return RoleRow.updatePermission; }

        protected form = new RoleForm(this.idPrefix);

        constructor() {
            super();

            this.form.PermissionSets.changeSelect2(() => {
                var permissionSets = this.form.PermissionSets.values;
                if (permissionSets && permissionSets.length) {
                    PermissionSetPermissionService.List({
                        PermissionSetCodes: permissionSets
                    },
                        response => {
                            this.form.GrantedPermissions.transitivePermissions = response.Entities;
                    })
                }
                else
                    this.form.GrantedPermissions.transitivePermissions = [];
            });

            noCommaValidationRule(this.form.RoleName, this.uniqueName);
        }

        protected arrange() {
            super.arrange();

            this.form.GrantedPermissions.element.css('height',
                Math.max(window.innerHeight - 420, 350) + 'px')
                .trigger('layout');
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.GrantedPermissions.transitivePermissions = this.entity.TransitivePermissions;
        }

        protected getLoadByIdRequest(id) {
            var opt = super.getLoadByIdRequest(id);
            opt.IncludeColumns = opt.IncludeColumns ?? [];
            opt.IncludeColumns.push(RoleRow.Fields.GrantedPermissions);
            opt.IncludeColumns.push(RoleRow.Fields.TransitivePermissions);
            return opt;
        }

        protected useViewMode() {
            return false;
        }
    }
}